export default "__VITE_ASSET__BWnn9FFQ__"